<template>
  <!-- Info affordance for a field whose value is shared across modules. Native
       title tooltip keeps it dependency-free; the label is fully localized. -->
  <span class="inline-flex items-center align-middle text-tertiary" :title="label">
    <LumiIcon name="info" class="w-4 h-4" />
    <span class="sr-only">{{ label }}</span>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { LumiIcon } from '@lumi/ui';

// `modules` is a list of module display names this field feeds; `owner` is where
// it can be changed later (People, by default).
const props = withDefaults(defineProps<{ modules: string[]; owner?: string }>(), {
  owner: '',
});

const { t } = useI18n();
const label = computed(() =>
  t('onboarding.wizard.crossRef', {
    modules: props.modules.join(', '),
    owner: props.owner || t('onboarding.wizard.crossRefOwnerDefault'),
  }),
);
</script>
